var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopeSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EnvelopeSimple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M70 17.5L40 45L10 17.5H70Z",
    fill: "#1C1C1C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M70 15H10C9.33696 15 8.70107 15.2634 8.23223 15.7322C7.76339 16.2011 7.5 16.837 7.5 17.5V60C7.5 61.3261 8.02678 62.5979 8.96447 63.5355C9.90215 64.4732 11.1739 65 12.5 65H67.5C68.8261 65 70.0979 64.4732 71.0355 63.5355C71.9732 62.5979 72.5 61.3261 72.5 60V17.5C72.5 16.837 72.2366 16.2011 71.7678 15.7322C71.2989 15.2634 70.663 15 70 15ZM63.5719 20L40 41.6094L16.4281 20H63.5719ZM67.5 60H12.5V23.1844L38.3094 46.8437C38.7706 47.2671 39.3739 47.5021 40 47.5021C40.6261 47.5021 41.2294 47.2671 41.6906 46.8437L67.5 23.1844V60Z",
    fill: "#1C1C1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSimple);
export default __webpack_public_path__ + "static/media/EnvelopeSimple.96d3f5a4a4d35836274f425c391d4d43.svg";
export { ForwardRef as ReactComponent };